export enum BookAppointmentViewTypes {
  AppointmentSlotsView = 0,
  TimeSlotsView = 1,
  AppointmentSummary = 2
}
